import { PiniaSharedState } from 'pinia-shared-state'

export default defineNuxtPlugin(() => {
  const { $pinia } = useNuxtApp()

  $pinia.use(PiniaSharedState({ enable: true, initialize: true }))
})
